module.exports = __webpack_public_path__ + "391f2b308bff2186e882422b1febfd3b.svg";